import React, { FC, MouseEvent } from 'react';
import { nuiCtx } from '../../common/initialization';
import { openDialog } from '../dialogs/dialogs';
import { isMobileChannel } from '../../common/util';
import { SvgIcon } from '../../icons/SvgIcon';
import i18n from '../../common/i18n';

export const SportBracketIcon: FC<{ sportBracketId: string }> = ({ sportBracketId }) => {
    const isMobileView = isMobileChannel();
    const iconSize = isMobileView ? '16' : '14';
    if (!sportBracketId) {
        return null;
    }
    return (
        <button
            onClick={openSportBracketDialog(sportBracketId)}
            className={'fs-0 btn-no-pad'}
            title={i18n('nui.sportbracket.iconTooltip')}
            data-atid="sportbracket-icon"
        >
            <SvgIcon imgId="sport-bracket" className={`mx-10 my-10`} sizeX={iconSize} sizeY={iconSize} />
        </button>
    );
};

export const openSportBracketDialog = (sportBracketId: string) => (e: MouseEvent<HTMLElement>): void => {
    e?.preventDefault();
    e?.stopPropagation();
    const { NuiDialog } = nuiCtx.components;
    const dialogName = 'nui/sportbracket/dialog';
    const url = `http://devbooking-fe-services.nike.sk:9051/api/sport-brackets/${sportBracketId}`;
    openDialog({
        name: dialogName,
        component: () => <NuiDialog name={dialogName}>{url}</NuiDialog>
    });
};
